// Global white-label configuration
// This file manages all brand identity and can be easily modified for different brands

export const siteConfig = {
  // Brand Identity - populated via CMS Quick Setup or /cms/branding
  appName: "",
  brandColor: "#d4af37",
  supportLineId: "",
  lineId: "",

  // URLs
  appUrl: process.env.NEXT_PUBLIC_APP_URL || "",

  // Contact - populated via CMS /cms/routing
  lineUrl: "",
  telegramUrl: "",
  facebookUrl: "",
  phone: "",
  email: "",

  // Business Rules
  minWithdraw: 100,
  minReferralClaim: 100,

  // Features
  features: {
    referralSystem: true,
    dailyQuests: true,
    vipSystem: true,
  },
} as const

export type SiteConfig = typeof siteConfig

export function useSiteConfig() {
  return siteConfig
}
